// extracted by mini-css-extract-plugin
export default {"colorInput":"ColorPicker_colorInput__6COgt"};